// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__axNze","title":"Info_title__1-HpO","selects":"Info_selects__2th58","requiredAsterisk":"Info_requiredAsterisk__vxxpF"};